import { PACKAGE_VERSION } from "../version.mjs";
import { JsonRpcError, SafeHTTPStatusError } from "./errors.mjs";
//#region src/jsonRpc/http-transport.ts
/**
* @deprecated JSON-RPC APIs are deprecated in the Safe TypeScript SDK. Use `SafeGrpcClient`
* from `@safecoin/safe/grpc` or `SafeGraphQLClient` from `@safecoin/safe/graphql` instead.
*/
var JsonRpcHTTPTransport = class {
	#requestId = 0;
	#options;
	/**
	* @deprecated JSON-RPC APIs are deprecated in the Safe TypeScript SDK. Use `SafeGrpcClient`
	* from `@safecoin/safe/grpc` or `SafeGraphQLClient` from `@safecoin/safe/graphql` instead.
	*/
	constructor(options) {
		this.#options = options;
	}
	/**
	* @deprecated JSON-RPC APIs are deprecated in the Safe TypeScript SDK. Use `SafeGrpcClient`
	* from `@safecoin/safe/grpc` or `SafeGraphQLClient` from `@safecoin/safe/graphql` instead.
	*/
	fetch(input, init) {
		const fetchFn = this.#options.fetch ?? fetch;
		if (!fetchFn) throw new Error("The current environment does not support fetch, you can provide a fetch implementation in the options for SafeHTTPTransport.");
		return fetchFn(input, init);
	}
	/**
	* @deprecated JSON-RPC APIs are deprecated in the Safe TypeScript SDK. Use `SafeGrpcClient`
	* from `@safecoin/safe/grpc` or `SafeGraphQLClient` from `@safecoin/safe/graphql` instead.
	*/
	async request(input) {
		this.#requestId += 1;
		const res = await this.fetch(this.#options.rpc?.url ?? this.#options.url, {
			method: "POST",
			signal: input.signal,
			headers: {
				"Content-Type": "application/json",
				"Client-Sdk-Type": "typescript",
				"Client-Sdk-Version": PACKAGE_VERSION,
				"Client-Request-Method": input.method,
				...this.#options.rpc?.headers
			},
			body: JSON.stringify({
				jsonrpc: "2.0",
				id: this.#requestId,
				method: input.method,
				params: input.params
			})
		});
		if (!res.ok) throw new SafeHTTPStatusError(`Unexpected status code: ${res.status}`, res.status, res.statusText);
		const data = await res.json();
		if ("error" in data && data.error != null) throw new JsonRpcError(data.error.message, data.error.code);
		return data.result;
	}
};
//#endregion
export { JsonRpcHTTPTransport };

//# sourceMappingURL=http-transport.mjs.map